/**
 * @prettier
 */

import createBehavior from '@js/functions/createBehavior.js';

const modalVideoShortsBehavior = createBehavior(
  'modal-video-shorts',
  {
    bindUI() {
      this.ui = {};
      this.ui.close = this.getChild('close');
      this.ui.iframe = this.getChild('iframe');
      this.ui.title = this.getChild('title');
      this.ui.progress = this.getChild('progress');
      this.ui.prev = this.getChild('prev');
      this.ui.next = this.getChild('next');
      this.ui.body = document.querySelector('body');

      this.state = {
        videos: [],
        currentIndex: 0,
      };
    },
    bindEvents() {
      this.ui.close.addEventListener('click', this.closeHandler, false);
      this.ui.prev.addEventListener('click', this.prevHandler, false);
      this.ui.next.addEventListener('click', this.nextHandler, false);

      document.addEventListener('card-video-shorts:open', this.onOpen, false);
      document.addEventListener('keydown', this.onKeydown, false);
    },
    onOpen(e) {
      this.state.videos = e.detail.videos;
      this.state.currentIndex = e.detail.index;

      this.renderProgress();
      this.loadVideo(this.state.currentIndex);
      this.updateNavVisibility();

      this.node.classList.add('is-visible');
      this.ui.body.classList.add('has-modal');
    },
    loadVideo(index) {
      const videoData = this.state.videos[index];
      if (!videoData) return;

      let videoSrc = '';
      if (videoData.type === 'youtube') {
        videoSrc =
          'https://www.youtube.com/embed/' +
          videoData.video_id +
          '?autoplay=1&mute=0&loop=' +
          videoData.loop +
          '&enablejsapi=true&playlist=' +
          videoData.video_id;
      } else if (videoData.type === 'freecaster') {
        videoSrc =
          '//' +
          videoData.freecasterDomain +
          '/embed/' +
          videoData.video_id +
          '?stretching=cover&autoplay=true&muted=false&loop=' +
          videoData.loop;
      }

      if (this.ui.iframe) {
        this.ui.iframe.src = videoSrc;
        this.ui.iframe.title = videoData.video_title || '';
      }

      if (this.ui.title) {
        this.ui.title.textContent = videoData.video_title || '';
      }

      if (window.fbq) {
        fbq('trackCustom', 'ShortPlay', {
          content_name: videoData.video_title || '',
          content_id: videoData.video_id || '',
        });
      }

      this.renderProgress();
      this.updateNavVisibility();
    },
    renderProgress() {
      const total = this.state.videos.length;
      if (!total || !this.ui.progress) return;

      let html = '';
      for (let i = 0; i < total; i++) {
        html +=
          '<span class="modal-video-shorts__progress-item' +
          (i === this.state.currentIndex ? ' is-active' : '') +
          '"></span>';
      }
      this.ui.progress.innerHTML = html;
    },
    updateNavVisibility() {
      const total = this.state.videos.length;
      if (this.ui.prev) {
        this.ui.prev.disabled = this.state.currentIndex === 0;
      }
      if (this.ui.next) {
        this.ui.next.disabled = this.state.currentIndex === total - 1;
      }
    },
    prevHandler() {
      if (this.state.currentIndex > 0) {
        this.state.currentIndex--;
        this.loadVideo(this.state.currentIndex);
      }
    },
    nextHandler() {
      if (this.state.currentIndex < this.state.videos.length - 1) {
        this.state.currentIndex++;
        this.loadVideo(this.state.currentIndex);
      }
    },
    closeHandler() {
      if (this.ui.iframe) this.ui.iframe.src = '';
      this.node.classList.remove('is-visible');
      this.ui.body.classList.remove('has-modal');
    },
    onKeydown(e) {
      if (!this.node.classList.contains('is-visible')) return;
      if (e.key === 'Escape') this.closeHandler();
      if (e.key === 'ArrowLeft') this.prevHandler();
      if (e.key === 'ArrowRight') this.nextHandler();
    },
  },
  {
    init() {
      this.bindUI();
      this.bindEvents();
    },
    destroy() {},
  },
);

export default modalVideoShortsBehavior;
